var exports = {
  "CJ": "Suggestions__dEtBZT",
  "Y9": "Header__8I5nU2",
  "DZ": "Heading__wMi5hI",
  "CW": "Cards__FkMFH-",
  "Zp": "Card__aRW9Ur",
  "u4": "SkeletonCard__R6nBwZ",
  "In": "Icon__ZpT6Yz",
  "hE": "Title__dTCH1p",
  "VY": "Description__M93g1b",
  "ry": "SkeletonIcon__wXce3x",
  "eg": "SkeletonTitle__2OGVLu",
  "Wi": "SkeletonDescription__XbCtvz",
  "_c": "reveal__TZ-Yxr",
  "U6": "pulse__aQzHUQ",
  "gN": "Reveal__ygEEe9",
};

module.exports = exports;
